import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

interface IProps {
  length: number;
  index: number;
}

export const ConditionalStepper: React.FC<IProps> = ({ length, index }) => {
  if (length !== 1 && index !== length - 1) {
    return <Spacer height="3x" />;
  }
  return null;
};
